module.exports = (__parcel__import__("2c3To")).then(() => parcelRequire('emu4l'));